@let loadingAlertDetailsFor = alertingFacade.loadingAlertDetailsFor$ | async;
@let selectedAlert = alertingFacade.selectedAlert$ | async;
@let evDriverIncident = isEvDriverIncident();
@let sessionAlert = isSessionAlert();
<div
  class="alert"
  tabindex="0"
  (click)="onSelectAlert($event)"
  (keydown.enter)="onSelectAlert($event)">
  <div
    class="content"
    [ngClass]="{
      unread: !evDriverIncident,
      expanded: loadingAlertDetailsFor === alert.id || selectedAlert?.alertId === alert.id,
    }">
    <div
      class="overview"
      [ngClass]="{
        expanded: loadingAlertDetailsFor === alert.id || selectedAlert?.alertId === alert.id,
      }">
      <eop-icon
        [identifier]="alertIcon"
        [color]="evDriverIncident ? IconColor.NORMAL : IconColor.ERROR"
        [vaylensFont]="true"></eop-icon>
      <div class="container-middle">
        <div class="description-container">
          <div class="description">
            @if (evDriverIncident) {
              <div class="sub-heading-l">
                {{ alert.details }}
              </div>
            } @else {
              <div class="sub-heading-l">
                {{ alert | alertDescription }}
              </div>
            }
          </div>
          <div class="sub-description">
            @if (alert.errorCode) {
              <eop-chip
                [chipColor]="ChipColor.ERROR"
                [chipSize]="ChipSize.SMALL"
                [text]="alert.errorCode | alertErrorCodeTranslationKey | translate"
                [maxWidth]="'120px'"
                [enableTitleTooltip]="true"></eop-chip>
            }
            @if (alert.deviceType === DeviceType.EVSE) {
              <eop-chip
                [chipColor]="ChipColor.LIGHT"
                [chipSize]="ChipSize.SMALL"
                [text]="alert.deviceId"
                [leftIcon]="
                  alert.deviceType === DeviceType.EVSE
                    ? 'charge-port-outlined'
                    : 'ic-charging-station'
                "
                [routerLink]="['/operate/chargingInfrastructureDetail']"
                [queryParams]="getStationDetailsParams(alert, DeviceType.EVSE)"
                [maxWidth]="'100px'"
                [enableTitleTooltip]="true"></eop-chip>
            }
            <eop-chip
              [chipColor]="ChipColor.LIGHT"
              [chipSize]="ChipSize.SMALL"
              [text]="alert.chargingStationName"
              [leftIcon]="'ic-charging-station'"
              [routerLink]="['/operate/chargingInfrastructureDetail']"
              [queryParams]="getStationDetailsParams(alert, DeviceType.STATION)"
              [maxWidth]="'100px'"
              [enableTitleTooltip]="true"></eop-chip>
          </div>
        </div>
        @if (alert.details && !evDriverIncident && !sessionAlert) {
          <div class="manufacturer">
            <div class="body-bold-s">{{ 'ALERTING.MANUFACTURER_INFO' | translate }}</div>
            <eop-chip
              [chipColor]="ChipColor.LIGHT"
              [chipSize]="ChipSize.SMALL"
              [text]="alert.details"
              [maxWidth]="'200px'"
              [enableTitleTooltip]="true"></eop-chip>
          </div>
        }
      </div>
      <div class="container-right">
        <div class="info-container">
          @if (alert.isStationMuted) {
            <eop-chip
              [chipColor]="ChipColor.WARNING"
              [chipSize]="ChipSize.MEDIUM"
              [iconColor]="IconColor.WARNING"
              [leftIcon]="'volume-mute-filled'"
              [leftIconTooltip]="alert.mutedUntil | mutedStationAlertsTooltip"
              [iconTooltipClass]="'multiline-tooltip'">
            </eop-chip>
          }
          <eop-chip
            [chipColor]="
              alert.alertStatus === AlertStatus.ACTIVE ? ChipColor.WARNING : ChipColor.SUCCESS
            "
            [chipSize]="ChipSize.MEDIUM"
            [text]="
              alert.alertStatus === AlertStatus.ACTIVE
                ? ('GLOBAL.ACTIVE' | translate)
                : ('ALERTING.RESOLVED' | translate)
            "></eop-chip>
        </div>
        @if (alert.alertStatus === AlertStatus.ACTIVE) {
          <div class="date-label">
            <div class="body-s">
              {{ 'GLOBAL.SINCE_CAPITAL' | translate }}
            </div>
            <div class="body-bold-s">
              {{ alert.created | userDateTime: true : false : true }}
            </div>
          </div>
        } @else {
          <div class="date-label">
            <div class="body-s">
              {{ 'GLOBAL.SINCE_CAPITAL' | translate }}
            </div>
            <div class="body-bold-s">
              {{ alert.resolved | userDateTime: true : false : true }}
            </div>
          </div>
        }
      </div>

      <div class="button-container">
        @if (hasManagePermission && menuItems.length) {
          <eop-menu-overlay [items]="menuItems" (itemClick)="onMenuItemSelected(alert, $event)">
            <eop-icon
              class="menu-icon"
              [identifier]="'more-3-filled'"
              [vaylensFont]="true"
              [clickable]="true"
              [color]="IconColor.NORMAL"
              [dataTestId]="'menu-icon-' + alert.id"></eop-icon>
          </eop-menu-overlay>
        }
        <eop-icon
          class="expand-icon"
          [identifier]="
            selectedAlert?.alertId === alert.id
              ? 'small-chevron-up-outlined'
              : 'small-chevron-down-outlined'
          "
          [vaylensFont]="true"
          [clickable]="true"
          [color]="IconColor.NORMAL"></eop-icon>
      </div>
    </div>
    @if (loadingAlertDetailsFor === alert.id || selectedAlert?.alertId === alert.id) {
      <div class="alert-details" [ngClass]="{ 'ev-driver-incident': evDriverIncident }">
        @if (loadingAlertDetailsFor === alert.id) {
          <spinner></spinner>
        }
        @if (selectedAlert?.alertId === alert.id) {
          @if (selectedAlert?.description && alert.alertType !== AlertType.CHARGING_SESSION) {
            <div class="alert-details-description body-m" style="white-space: pre-line">
              {{ selectedAlert?.description }}
            </div>
          }
          @if (selectedAlert?.isEvDriverIncident) {
            <div class="alert-details-containers">
              <div class="detail-box">
                <div class="sub-heading-m">{{ 'ALERTING.CASE_INFORMATION' | translate }}</div>
                <eop-grid-list
                  [columns]="
                    selectedAlert?.reporter?.name ||
                    selectedAlert?.reporter?.email ||
                    selectedAlert?.reporter?.phone
                      ? 3
                      : 6
                  ">
                  <div class="alert-detail-content">
                    <div class="body-s alert-detail-title">
                      {{ 'ALERTING.TICKET_NUMBER' | translate }}
                    </div>
                    <div class="body-m alert-label">{{ selectedAlert.caseNumber }}</div>
                  </div>
                  <div class="alert-detail-content">
                    <div class="body-s alert-detail-title">
                      {{ 'ARCHIVED_USERS.CREATION_DATE' | translate }}
                    </div>
                    <div class="body-m alert-label">
                      {{ selectedAlert.created | userDateTime: true : false : true }}
                    </div>
                  </div>
                </eop-grid-list>
              </div>
              @if (
                selectedAlert?.reporter?.name ||
                selectedAlert?.reporter?.email ||
                selectedAlert?.reporter?.phone
              ) {
                <div class="detail-box">
                  <div class="sub-heading-m">{{ 'ALERTING.REPORTER_DETAILS' | translate }}</div>

                  <eop-grid-list>
                    @if (selectedAlert?.reporter?.name) {
                      <div class="alert-detail-content">
                        <div class="body-s alert-detail-title">{{ 'GLOBAL.NAME' | translate }}</div>
                        <div class="body-m alert-label">
                          {{ selectedAlert.reporter.name }}
                        </div>
                      </div>
                    }
                    @if (selectedAlert?.reporter?.email) {
                      <div class="alert-detail-content">
                        <div class="body-s alert-detail-title">
                          {{ 'GLOBAL.EMAIL' | translate }}
                        </div>
                        <div class="body-m alert-label">
                          {{ selectedAlert.reporter.email }}
                        </div>
                      </div>
                    }
                    @if (selectedAlert?.reporter?.phone) {
                      <div class="alert-detail-content">
                        <div class="body-s alert-detail-title">
                          {{ 'GLOBAL.PHONE_NUMBER' | translate }}
                        </div>
                        <div class="body-m alert-label">
                          {{ selectedAlert.reporter.phone }}
                        </div>
                      </div>
                    }
                  </eop-grid-list>
                </div>
              }
            </div>
          } @else {
            @if (alert.alertType === AlertType.CHARGING_SESSION) {
              <div class="alert-details-containers">
                <div class="detail-box">
                  <eop-session-alert-details
                    [alert]="alert"
                    [sessionAlertDetails]="selectedAlert?.sessionAlertDetails ?? null"
                    [description]="selectedAlert?.description ?? null"
                    [partnerId]="partnerId"></eop-session-alert-details>
                </div>
              </div>
            }
            <div class="alert-details-containers">
              <div class="detail-box">
                <div class="sub-heading-m">
                  {{ 'ALERTING.CHARGING_STATION_DETAILS' | translate }}
                </div>

                <eop-grid-list [columns]="1">
                  <div class="alert-detail-content">
                    <div class="body-s alert-detail-title">
                      {{
                        (alert.deviceType === DeviceType.EVSE
                          ? 'GLOBAL.CHARGE_POINT'
                          : 'GLOBAL.CHARGING_STATION'
                        ) | translate
                      }}
                    </div>
                    <div class="icon-with-text">
                      <eop-icon
                        [identifier]="
                          alert.deviceType === DeviceType.EVSE
                            ? 'charge-port-outlined'
                            : 'ic-charging-station'
                        "
                        [vaylensFont]="true"
                        [size]="IconSize.SMALL"
                        [color]="IconColor.NORMAL"></eop-icon>
                      <div class="body-m status-label">
                        {{ alert.deviceId }}
                      </div>
                    </div>
                    <div class="icon-with-text small">
                      <eop-icon
                        [identifier]="'location-outlined'"
                        [vaylensFont]="true"
                        [size]="IconSize.MINI"
                        [color]="IconColor.NORMAL"></eop-icon>
                      <div class="body-s status-label">
                        {{ alert.address.street | empty }},
                        {{ alert.address | location: LocationTypes.LINE2 | empty }},
                        {{
                          alert.address.country
                            ? ('GLOBAL.' + alert.address.country | translate)
                            : ''
                        }}
                      </div>
                    </div>
                    <button
                      eopButton
                      class="link"
                      [size]="ButtonSize.SMALL"
                      [color]="ButtonColor.SECONDARY"
                      [rightIcon]="'arrow-right-outlined'"
                      [dataTestId]="'go-to-station-details'"
                      [routerLink]="['/operate/chargingInfrastructureDetail']"
                      [queryParams]="getStationDetailsParams(alert, alert.deviceType)">
                      {{ 'ALERTING.CHARGING_STATION_DETAILS' | translate }}
                    </button>
                  </div>
                  @if (hasManagePermission && alert.groups?.length > 0) {
                    <div class="alert-detail-content">
                      <div class="body-s alert-detail-title">
                        {{ 'ALERTING.STATION_GROUP' | translate }}
                      </div>
                      <div class="alert-groups">
                        @for (group of alert.groups; track group) {
                          <eop-chip
                            [chipColor]="ChipColor.LIGHT"
                            [chipSize]="ChipSize.SMALL"
                            [text]="group"
                            [leftIcon]="'folder-1-open-outlined'"></eop-chip>
                        }
                      </div>
                    </div>
                  }
                </eop-grid-list>
              </div>
            </div>
            <div class="alert-details-containers">
              <div class="detail-box">
                <div class="sub-heading-m">
                  {{ 'ALERTING.CONFIGURATION_DETAILS' | translate }}
                </div>

                <div class="alert-detail-content">
                  <div class="body-s alert-detail-title">
                    {{ 'GLOBAL.CONFIGURATION' | translate }}
                  </div>
                  <div class="icon-with-text">
                    <eop-icon
                      [identifier]="'settings-4-outlined'"
                      [vaylensFont]="true"
                      [size]="IconSize.SMALL"
                      [color]="IconColor.NORMAL"></eop-icon>
                    <div class="body-m status-label">
                      {{ 'ALERTING.ALERT_STATUS_' + alert.alertType | translate }}
                    </div>
                  </div>
                  @if (hasManagePermission) {
                    <button
                      eopButton
                      class="link"
                      [size]="ButtonSize.SMALL"
                      [color]="ButtonColor.SECONDARY"
                      [rightIcon]="'arrow-right-outlined'"
                      [dataTestId]="'go-to-alert-settings'"
                      [routerLink]="['/monitor/alerting']"
                      [queryParams]="{
                        activeTab: 2,
                        preSelectedType: alert.alertType,
                      }">
                      {{ 'ALERTING.ALARM_SETTINGS_NEW' | translate }}
                    </button>
                  }
                </div>
              </div>
            </div>
            <div class="alert-details-containers">
              <div class="detail-box">
                <div class="sub-heading-m">
                  {{ 'ALERTING.ALERT_DURATION' | translate }}
                </div>
                <div class="detail-status">
                  <div class="body-m">
                    {{ 'ALERTING.ALERT_STATUS_' + alert.alertType | translate }}
                  </div>
                  <eop-chip
                    [chipColor]="
                      alert.alertStatus === AlertStatus.ACTIVE
                        ? ChipColor.WARNING
                        : ChipColor.SUCCESS
                    "
                    [chipSize]="ChipSize.SMALL"
                    [text]="
                      alert.alertStatus === AlertStatus.ACTIVE
                        ? ('GLOBAL.ACTIVE' | translate)
                        : ('ALERTING.RESOLVED' | translate)
                    "></eop-chip>
                </div>
                <eop-duration-info
                  [startLabel]="'ALERTING.ACTIVE_SINCE' | translate"
                  [endLabel]="'ALERTING.RESOLVED_AT' | translate"
                  [start]="alert.created"
                  [end]="alert.resolved"></eop-duration-info>
              </div>
            </div>
          }
        }
      </div>
    }
  </div>
</div>
